<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';

export default {
  name: 'ConfidentialityForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
  },
  props: {
    tom: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.entryControlDesc"
            property-code="tom.entryControlDesc"
            label="Beschreibung der Zutrittskontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.admissionControlDesc"
            property-code="tom.admissionControlDesc"
            label="Beschreibung der Zugangskontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.accessControlDesc"
            property-code="tom.accessControlDesc"
            label="Beschreibung der Zugriffskontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.separationCommandDesc"
            property-code="tom.separationCommandDesc"
            label="Beschreibung des Trennungsgebots"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.pseudonymizationDesc"
            property-code="tom.pseudonymizationDesc"
            label="Beschreibung der Pseudonymisierung"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
